/** Mirrors server/db.ts: contract-linked installations only update fields not owned by the canonical contract. */
const CONTRACT_LINKED_WRITE_PROTECTED_FIELDS = new Set([
  // Relationship fields: rejected by the generic installation updater for every installation.
  "primaryCustomerPartnerId",
  "siteId",
  "contractId",
  "installationCode",
  // Identity snapshots and contract-owned economics/configuration.
  "clientId",
  "clientName",
  "clientDocument",
  "clientPhone",
  "clientEmail",
  "address",
  "installationPrice",
  "budget",
  "contractStatus",
  "contractDocumentId",
  "billingConfigStatus",
  "billingConfigValidatedAt",
  "billingConfigValidatedBy",
  "billingWarningLevel",
  "billingOverrideReason",
  "billingOverrideBy",
  "billingOverrideAt",
  "billingRequirementMode",
  "isBillableBreakdown",
  "includesMaintenance",
  "maintenancePaymentStatus",
]);

export function installationUpdatePayload<T extends Record<string, unknown>>(
  isContractLinked: boolean,
  fields: T,
): T {
  if (!isContractLinked) return fields;
  return Object.fromEntries(
    Object.entries(fields).filter(([field]) => !CONTRACT_LINKED_WRITE_PROTECTED_FIELDS.has(field)),
  ) as T;
}

export function shouldUpdateInstallationBillingConfig(
  isContractLinked: boolean,
  showBillingConfig: boolean,
  showMaintenancePaymentConfig: boolean,
): boolean {
  return !isContractLinked && (showBillingConfig || showMaintenancePaymentConfig);
}
